export default __webpack_public_path__ + "static/part2-screenshot-fb87cfc9810be52a5d8ddde8b7ac7ed7.png";